var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "create-contract container container_30" },
    [
      !_vm.contractCreated
        ? [
            _c(
              "form",
              {
                attrs: { novalidate: "" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.submit.apply(null, arguments)
                  }
                }
              },
              [
                _c("div", { staticClass: "create-contract__title" }, [
                  _vm._v(_vm._s(_vm.i18n.cont_new_contract()))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "create-contract__fields-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "create-contract__field" },
                    [
                      _c("input-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          name: "contract-counterparty",
                          title: "Counterparty",
                          label: _vm.i18n.cont_counterparty_email_or_id()
                        },
                        model: {
                          value: _vm.form.counterparty,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "counterparty", $$v)
                          },
                          expression: "form.counterparty"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "create-contract__field" },
                    [
                      _c("input-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          name: "contract-number",
                          title: "Contract number",
                          label: _vm.i18n.cont_contract_number()
                        },
                        model: {
                          value: _vm.form.contractNumber,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "contractNumber", $$v)
                          },
                          expression: "form.contractNumber"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "create-contract__fields-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "create-contract__field" },
                    [
                      _c("date-field-flatpickr", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        key: "create-contract-" + _vm.form.endTime,
                        attrs: {
                          name: "contract-start-date",
                          title: "Contract start date",
                          disableBefore: new Date().toString(),
                          disableAfter: _vm.form.endTime,
                          label: _vm.i18n.lbl_start_date()
                        },
                        model: {
                          value: _vm.form.startTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "startTime", $$v)
                          },
                          expression: "form.startTime"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "create-contract__field" },
                    [
                      _c("date-field-flatpickr", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        key: "create-contract-" + _vm.form.startTime,
                        attrs: {
                          name: "contract-end-date",
                          title: "Contract end date",
                          disableBefore: _vm.disableBeforeDate(),
                          label: _vm.i18n.lbl_end_date()
                        },
                        model: {
                          value: _vm.form.endTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "endTime", $$v)
                          },
                          expression: "form.endTime"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "create-contract__fields-wrapper--secondary" },
                  [
                    _c(
                      "div",
                      { staticClass: "create-contract__document-wrapper" },
                      [
                        _c("h3", { staticClass: "field-title" }, [
                          _vm._v(_vm._s(_vm.i18n.lbl_document()))
                        ]),
                        _vm._v(" "),
                        _c("file-field", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            fileType: "image",
                            name: "contract-file-field",
                            type: _vm.documentTypes.contract
                          },
                          model: {
                            value: _vm.documents.contract,
                            callback: function($$v) {
                              _vm.$set(_vm.documents, "contract", $$v)
                            },
                            expression: "documents.contract"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "create-contract__note-wrapper" },
                      [
                        _c("h3", { staticClass: "field-title" }, [
                          _vm._v(_vm._s(_vm.i18n.lbl_note()))
                        ]),
                        _vm._v(" "),
                        _c("textarea-field", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: { name: "contract-note-field" },
                          model: {
                            value: _vm.form.note,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "note", $$v)
                            },
                            expression: "form.note"
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "create-contract__submit-wrapper" },
                  [
                    _c(
                      "md-button",
                      {
                        staticClass: "md-primary btn",
                        attrs: { type: "submit", disabled: _vm.isPending }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.i18n.cont_sign_and_send()) +
                            "\n        "
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        : [
            _c("contracts-details", {
              attrs: {
                id: _vm.requestId,
                type: _vm.CONTRACTS_DETAILS_TYPES.requests
              },
              on: {
                "close-details": function($event) {
                  _vm.contractCreated = false
                }
              }
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c25dedd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c25dedd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/contracts/index/new/Contracts.CreateNew.vue
// module id = lzJ0
// module chunks = 1